// extracted by mini-css-extract-plugin
export var chevronIcon = "_bb-2";
export var teamName = "_bb-1";
export var teamSwitcherButton = "_bb-0";